import { animated, useSpring } from '@react-spring/web'
import React from 'react'

const AnimateOpacity = ({ isOpen, children }: { isOpen: boolean, children: React.ReactNode }) => {
  const opacity = isOpen ? 1 : 0

  const styles = useSpring({
    opacity,
    from: { opacity: 0 },
  })

  return (
    <animated.span
      className='ease-linear transition duration-100 overflow-hidden block'
      style={styles}
    >
      <div>
        {children}
      </div>
    </animated.span>
  )
}

export default AnimateOpacity
